export class ClientUnexpectedError extends Error {
  constructor() {
    super();
  }
}
